import { h } from '@stencil/core';
import cn from 'classnames';
export class CustomQdsIconComponent {
  constructor() {
    this.iconName = undefined;
    this.customStyles = undefined;
    this.customClasses = undefined;
  }
  render() {
    return (h("span", { class: cn('qds-icon__wrapper', { [this.customClasses]: !!this.customClasses }), style: this.customStyles }, h("qds-icon", { name: this.iconName, class: 'pes-qds--icon' })));
  }
  static get is() { return "pes-custom-qds-icon"; }
  static get originalStyleUrls() {
    return {
      "$": ["custom-qds-icon.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["custom-qds-icon.css"]
    };
  }
  static get properties() {
    return {
      "iconName": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "icon-name",
        "reflect": false
      },
      "customStyles": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "Record<string, string>",
          "resolved": "{ [x: string]: string; }",
          "references": {
            "Record": {
              "location": "global"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Optional property that defines custom style for icon."
        }
      },
      "customClasses": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Optional property that defines custom class to apply for icon."
        },
        "attribute": "custom-classes",
        "reflect": false
      }
    };
  }
}
